export default __webpack_public_path__ + "f101c2a5b9f0c457e3fff50ac5e0f0a5.png";